module.exports = __webpack_public_path__ + "img/2._Bergungsgruppe.a33bb446.svg";